module.exports = __webpack_public_path__ + "static/investment-d01c8343adbf23a62a83fe70eb20a528.png";